import RequireUser from "./RequireUser";

const RequireOperator = (props) => {
	const { children } = props;
	return <RequireUser requireOperator={true} >{children}</RequireUser>
}

export default RequireOperator